import { addMonetaryValues, BookingFeeMode, configurationSettings } from '@vista/omnichannel-components-domain';
export const getKeyForOrderTicketLine = (ticketLine) => {
    var _a;
    const { ticketTypeId, price, bookingFee } = ticketLine;
    return `${ticketTypeId}.${price}.${(_a = bookingFee === null || bookingFee === void 0 ? void 0 : bookingFee.amount) !== null && _a !== void 0 ? _a : 0}`;
};
/**
 * Groups a given set of order ticket lines by their ticketTypeId and price.
 *
 * TODO: Remove this in favour of using getGroupedLines instead. #288224
 */
export function groupOrderTicketLinesByIdAndPrice(tickets) {
    const ticketMap = tickets.reduce((map, ticket) => {
        var _a;
        const key = getKeyForOrderTicketLine(ticket);
        const ticketPrice = configurationSettings.data.order.bookingFeeMode === BookingFeeMode.Inclusive
            ? addMonetaryValues(ticket.price, (_a = ticket.bookingFee) === null || _a === void 0 ? void 0 : _a.amount)
            : ticket.price;
        const existingTicket = ticket.ticketTypeId ? map.get(key) : undefined;
        if (existingTicket) {
            existingTicket.quantity++;
            existingTicket.totalPrice = addMonetaryValues(existingTicket.totalPrice, ticketPrice);
        }
        else {
            map.set(key, {
                ticketTypeId: ticket.ticketTypeId,
                firstId: ticket.id,
                quantity: 1,
                totalPrice: ticketPrice
            });
        }
        return map;
    }, new Map());
    return Array.from(ticketMap, ([_, groupedTicket]) => groupedTicket);
}
